<template>
  <div :class="containerClasses">
    <slot />
  </div>
</template>

<script setup lang="ts">
/* eslint no-unused-vars:off */
import { computed, defineProps, PropType } from "vue";
import {
  VALID_CONTAINER_VALUES,
  VALID_PADDING_VALUES,
  VALID_MARGIN_VALUES,
  RESPONSIVE_SPACING_VALUES,
} from "@/designSystem/Grid/constant";
import type { ContainerType, PaddingType, MarginType } from "@/designSystem/Grid/constant";

const props = defineProps({
  type: {
    type: String as PropType<ContainerType>,
    default: "container",
    validator: (value: string): value is ContainerType => VALID_CONTAINER_VALUES.includes(value as ContainerType),
  },

  padding: {
    type: String as PropType<PaddingType>,
    default: null,
    validator: (value: string | null): value is PaddingType =>
      value === null || VALID_PADDING_VALUES.includes(value as PaddingType),
  },

  margin: {
    type: String as PropType<MarginType>,
    default: null,
    validator: (value: string | null): value is MarginType =>
      value === null || VALID_MARGIN_VALUES.includes(value as MarginType),
  },
});

const containerClasses = computed(() =>
  [
    props.type,
    props.padding ? RESPONSIVE_SPACING_VALUES[props.padding].map((text) => "p-" + text).join(" ") : "",
    props.margin ? RESPONSIVE_SPACING_VALUES[props.margin].map((text) => "m-" + text).join(" ") : "",
  ]
    .filter(Boolean)
    .join(" ")
);
</script>

<style lang="scss" scoped>
@import "@/designSystem/style/main.scss";
@import "@/designSystem/Grid/cx-grid.scss";
</style>
